module.exports = __webpack_public_path__ + "static/media/place-footer.ca107c04.svg";